module.exports = __webpack_public_path__ + "assets/images/frame-br-3.556bdbc6bd342588c13514056533b7b1.png";